import "bootstrap/dist/css/bootstrap.min.css";
import { Alert, Card, ListGroup, ListGroupItem, Form, Stack, Dropdown, Button } from "react-bootstrap"
import { UserContext } from "../context/UserContext";
import { useState, useContext, useEffect, useCallback } from "react";
import { useFetchData } from "../helpers/FetchDataHelpers";
import { toast } from "react-toastify";
import ScaleDetails from "./ScaleDetails";
import ScaleGatewayDetails from "./ScaleGatewayDetails";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa"
import { FaWeightScale } from "react-icons/fa6";
import { HiDuplicate } from "react-icons/hi";
import { PiNetworkFill } from "react-icons/pi";
import { useForm } from "react-hook-form";


export default function GondolaDetails(props) {

    const actions = {
        EDIT: 'EDIT',
        DUPLICATE: 'DUPLICATE',
        DELETE: 'DELETE',
        ADD_GATEWAY: 'ADD_GATEWAY',
        ADD_SCALES: 'ADD_SCALES',
        NO_ACTION: 'NO_ACTION'
    }

    const { gondolaBox, deploymentId, refetchGondolas, hidePanel } = props;
    const [gondolaInfo, setGondolaInfo] = useState(null);
    const [ongoingAction, setOngoingAction] = useState(actions.NO_ACTION);
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [addScaleResultMessages, setAddScaleResultMessages] = useState([]);

    const { userenv } = useContext(UserContext);

    const { register: registerFormGondola, handleSubmit: handleSubmitFormGondola, reset: resetFormGondola, setValue: setValueFormGondola } = useForm();
    const { register: registerFormGateway, handleSubmit: handleSubmitFormGateway, reset: resetFormGateway } = useForm();
    const { register: registerFormScale, handleSubmit: handleSubmitFormScale, reset: resetFormScale } = useForm();

    const fetchData = useFetchData();
    const gondolaId = gondolaBox.gondola.gondola_id;

    const fetchGondolaInfo = useCallback(async () => {
        const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`
        const url = baseUrl + `/gondolas/${gondolaId}`;
        const { isResponseOK, data, errorMessage } = await fetchData(url);
        if (isResponseOK && data) {
            setGondolaInfo(data);
        }
        else {
            toast.error("Error: " + errorMessage);
        }
    }, [userenv, deploymentId, fetchData, gondolaId]);

    useEffect(() => {
        fetchGondolaInfo();
    }, [fetchGondolaInfo]);

    const onDuplicateGondola = () => {
        const duplicateGondola = async () => {
            setButtonsDisabled(true);
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`
            const url = baseUrl + `/gondolas/${gondolaId}/duplicate`;
            const { isResponseOK, errorMessage } = await fetchData(url, "POST");
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            } else {
                toast.success("Gondola duplicated successfully!");
                setOngoingAction(actions.NO_ACTION);
                refetchGondolas(deploymentId);
            }
            setButtonsDisabled(false);
        };
        duplicateGondola();
    };

    const onAddGateway = (data) => {
        setButtonsDisabled(true);
        const addGateway = async () => {
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`;
            const url = baseUrl + `/gondolas/${gondolaId}/gateways`;
            const body = JSON.stringify(data);
            const { isResponseOK, errorMessage } = await fetchData(url, "POST", false, body);
            
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            } else {
                toast.success("Gateway added successfully!");
                setOngoingAction(actions.NO_ACTION);
                fetchGondolaInfo();
            }

            setButtonsDisabled(false);
        }
        addGateway();
    };

    const onAddScales = (data) => {
        const addScale = async () => {
            setButtonsDisabled(true);
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`;
            const url = baseUrl + `/gondolas/${gondolaId}/scales/${data.serial_number}`;
            const { isResponseOK, errorMessage } = await fetchData(url, "POST");
            
            if (!isResponseOK) {
                setAddScaleResultMessages([...addScaleResultMessages, "Error: " + errorMessage])
            } else {
                setAddScaleResultMessages([...addScaleResultMessages, "Added scale " + data.serial_number + " successfully."])
            }
            setButtonsDisabled(false);
        }
        addScale();
    }

    const onEditGondola = (data) => {
        let newGondolaInfo = gondolaInfo;

        newGondolaInfo.gondola_external_id = data.gondola_external_id
        newGondolaInfo.img_pos_x = data.img_pos_x
        newGondolaInfo.img_pos_y = data.img_pos_y
        newGondolaInfo.dimensions_x = data.dimensions_x
        newGondolaInfo.dimensions_y = data.dimensions_y
        newGondolaInfo.yaw = data.yaw


        const updateGondolaJson = {
            "gondola_id": gondolaInfo.gondola_id,
            "gondola_backend_id": gondolaInfo.backend_id,
            "gondola_external_id": data.gondola_external_id,
            "img_pos_x": data.img_pos_x,
            "img_pos_y": data.img_pos_y,
            "dimensions_x": data.dimensions_x,
            "dimensions_y": data.dimensions_y,
            "yaw": data.yaw
        };

        const editGondola = async () => {
            setButtonsDisabled(true);
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`;
            const url = baseUrl + `/gondolas`;
            const body = JSON.stringify(updateGondolaJson);
            const { isResponseOK, errorMessage } = await fetchData(url, "PATCH", false, body);
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            } else {
                setGondolaInfo(newGondolaInfo);
                toast.success("Gondola updated successfully!");
                refetchGondolas(deploymentId);
                setOngoingAction(actions.NO_ACTION);
            }
            setButtonsDisabled(false);
        }
        editGondola();
    };

    const onRemoveGondola = () => {
        const removeGondola = async () => {
            setButtonsDisabled(true);
            const baseUrl = `${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/store-deployments/${userenv}/${deploymentId}`
            const url = baseUrl + `/gondolas/${gondolaId}`;
            const { isResponseOK, errorMessage } = await fetchData(url, "DELETE");
            if (!isResponseOK) {
                toast.error("Error: " + errorMessage);
            } else {
                toast.success("Gondola deleted successfully!");
                refetchGondolas(deploymentId);
                setOngoingAction(actions.NO_ACTION);
                hidePanel();
            }
            setButtonsDisabled(false);
        };
        removeGondola();
    };

    if (!gondolaInfo) {
        return (
            <Card className="App-labels mb-5 ">
                <Card.Body className="Card-body">
                    <Card.Title className="mb-3">Gondola Data</Card.Title>
                    Fetching gondola details...
                </Card.Body>
            </Card>
        )
    }

    return (
        <Stack gap={3}>
            <Stack direction="horizontal" gap={3} className="justify-content-between align-items-center">
                <h5>Gondola {gondolaInfo.gondola_external_id}</h5>
                <Dropdown>
                    <Dropdown.Toggle variant="secondary" size="sm" disabled={buttonsDisabled}>
                        Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => { resetFormGondola(); setOngoingAction(actions.EDIT) }}>
                            <FaEdit className="me-2" />
                            Edit
                        </Dropdown.Item>
                        <Dropdown.Item disabled={false} onClick={() => { setOngoingAction(actions.DUPLICATE) }}>
                            <HiDuplicate className="me-2" />
                            Duplicate
                        </Dropdown.Item>
                        <Dropdown.Item disabled={false} onClick={() => { setOngoingAction(actions.DELETE) }}>
                            <FaTrash className="me-2" />
                            Delete
                        </Dropdown.Item>
                        <Dropdown.Item disabled={false} onClick={() => { resetFormGateway(); setOngoingAction(actions.ADD_GATEWAY) }}>
                            <PiNetworkFill className="me-2" />
                            Add Gateway
                        </Dropdown.Item>
                        {gondolaInfo.gateways.length > 0 &&
                            <Dropdown.Item disabled={false} onClick={() => { resetFormScale(); setOngoingAction(actions.ADD_SCALES) }}>
                                <FaWeightScale className="me-2" />
                                Add Scales
                            </Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
            </Stack>

            {ongoingAction === actions.DUPLICATE &&
                <Stack gap={3} direction="horizontal" >
                    <span>
                        Duplicate Gondola ?
                    </span>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="danger" size="sm" onClick={() => { setOngoingAction(actions.NO_ACTION); }}>
                        Cancel
                    </Button>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="success" size="sm" onClick={() => { onDuplicateGondola(); setOngoingAction(actions.NO_ACTION); }}>
                        Confirm
                    </Button>
                </Stack>
            }

            {ongoingAction === actions.DELETE &&
                <Stack gap={3} direction="horizontal" >
                    <span>
                        Delete Gondola ?
                    </span>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="danger" size="sm" onClick={() => { setOngoingAction(actions.NO_ACTION); }}>
                        Cancel
                    </Button>
                    <Button disabled={buttonsDisabled} className="flex-grow-1" variant="success" size="sm" onClick={() => { onRemoveGondola(); setOngoingAction(actions.NO_ACTION); }}>
                        Confirm
                    </Button>
                </Stack>
            }

            {ongoingAction === actions.EDIT &&
                <Form noValidate onSubmit={handleSubmitFormGondola(onEditGondola)}>
                    <div className="mb-3 fw-bold">
                        Edit Gondola
                    </div>
                    <Form.Group controlId="form.EditGondola">
                        {gondolaInfo !== null && setValueFormGondola("gondola_external_id", gondolaInfo.gondola_external_id)}
                        {gondolaInfo !== null && setValueFormGondola("img_pos_x", gondolaInfo.img_pos_x)}
                        {gondolaInfo !== null && setValueFormGondola("img_pos_y", gondolaInfo.img_pos_y)}
                        {gondolaInfo !== null && setValueFormGondola("yaw", gondolaInfo.yaw)}
                        {gondolaInfo !== null && setValueFormGondola("dimensions_x", gondolaInfo.dimensions_x)}
                        {gondolaInfo !== null && setValueFormGondola("dimensions_y", gondolaInfo.dimensions_y)}

                        <Form.Label>External Id:</Form.Label>
                        <Form.Control type="text" placeholder="<external id>" {...registerFormGondola("gondola_external_id")} />
                        <Form.Label className="mt-3">Position (x):</Form.Label>
                        <Form.Control type="text" {...registerFormGondola("img_pos_x")} />
                        <Form.Label className="mt-3">Position (y):</Form.Label>
                        <Form.Control type="text" {...registerFormGondola("img_pos_y")} />
                        <Form.Label className="mt-3">Dimension (x):</Form.Label>
                        <Form.Control type="text" {...registerFormGondola("dimensions_x")} />
                        <Form.Label className="mt-3">Dimension (y):</Form.Label>
                        <Form.Control type="text" {...registerFormGondola("dimensions_y")} />
                        <Form.Label className="mt-3">Rotation:</Form.Label>
                        <Form.Control type="text" {...registerFormGondola("yaw")} />
                    </Form.Group>
                    <Stack gap={3} direction="horizontal" className="mt-3">
                        <Button className="flex-grow-1" size="sm" variant="danger" onClick={() => { resetFormGondola(); setOngoingAction(actions.NO_ACTION); }}>
                            Cancel
                        </Button>
                        <Button type="submit" className="flex-grow-1" size="sm" variant="primary">
                            Save
                        </Button>
                    </Stack>
                </Form>
            }

            {ongoingAction === actions.ADD_GATEWAY &&
                <Form noValidate onSubmit={handleSubmitFormGateway(onAddGateway)} >
                    <Form.Group controlId="form.AddGateway">
                        <div className="mb-3 fw-bold">
                            Add Gateway
                        </div>
                        <Form.Label>Mac Address:</Form.Label>
                        <Form.Control type="text" placeholder="<mac_address>" autoFocus
                            {...registerFormGateway("mac_address", { required: true })} />
                        <Stack gap={3} direction="horizontal" className="mt-3">
                            <Button className="flex-grow-1" size="sm" variant="danger" onClick={() => { resetFormGateway(); setOngoingAction(actions.NO_ACTION); }}>
                                Cancel
                            </Button>
                            <Button type="submit" className="flex-grow-1" size="sm" variant="primary">
                                Save
                            </Button>
                        </Stack>
                    </Form.Group>
                </Form>
            }


            {ongoingAction === actions.ADD_SCALES &&
                <Form noValidate onSubmit={handleSubmitFormScale(onAddScales)} >
                    <Form.Group controlId="form.AddScale">
                        <Form.Label>Serial Number:</Form.Label>
                        <Form.Control type="number" placeholder="<serial_number>" autoFocus
                            {...registerFormScale("serial_number", { required: true, valueAsNumber: true })} />
                        <Stack gap={3} direction="horizontal" className="mt-3">
                            <Button disabled={buttonsDisabled} className="flex-grow-1" size="sm" variant="danger" 
                                onClick={() => { 
                                    resetFormScale(); 
                                    fetchGondolaInfo();
                                    setAddScaleResultMessages([]);
                                    setOngoingAction(actions.NO_ACTION); }}
                            >
                                End
                            </Button>
                            <Button disabled={buttonsDisabled} type="submit" className="flex-grow-1" size="sm" variant="primary">
                                Add
                            </Button>
                        </Stack>
                    </Form.Group>
                    {addScaleResultMessages.map((message, index) =>
                        <Alert variant={message.includes("Error") ? "danger" : "success"} className="mt-3" key={index}>{message}</Alert>
                    )}
                </Form>
            }

            {ongoingAction === actions.NO_ACTION &&
                <ListGroup>
                    <ListGroupItem> External Id: {gondolaInfo.gondola_external_id} </ListGroupItem>
                    <ListGroupItem> Backend Id: {gondolaInfo.backend_id} </ListGroupItem>
                    <ListGroupItem>
                        Cameras: &nbsp; {'[' + gondolaInfo.cameras.map(id => id.toString()).join(', ') + ']'}
                    </ListGroupItem>
                    <ListGroupItem>
                        Calibrated: &nbsp; &nbsp;
                        <Form.Check inline disabled checked={gondolaInfo.is_calibrated} type="checkbox" />
                    </ListGroupItem>
                    <ListGroupItem>
                        Scale Count: {gondolaInfo.scales.length} &nbsp;
                    </ListGroupItem>
                    <ListGroupItem>
                        Gateway Count: &nbsp; {gondolaInfo.gateways.length}
                    </ListGroupItem>
                    <ListGroupItem> Position (pixels): {gondolaBox.gondola.img_pos_x}, {gondolaBox.gondola.img_pos_y} </ListGroupItem>
                    <ListGroupItem>
                        Dimensions (pixels): &nbsp; {gondolaInfo.dimensions_x}, {gondolaInfo.dimensions_y}
                    </ListGroupItem>
                    <ListGroupItem>
                        Rotation (angle): &nbsp; {gondolaInfo.yaw}
                    </ListGroupItem>
                </ListGroup>}

            {ongoingAction === actions.NO_ACTION && gondolaInfo && gondolaInfo.scales.map(scale =>
                <ScaleDetails key={scale.scale_id}
                    scale={scale}
                    gondolaId={gondolaId}
                    deploymentId={deploymentId}
                    gateways={gondolaInfo.gateways}
                    refetchGondolaInfo={fetchGondolaInfo}
                />)
            }

            {ongoingAction === actions.NO_ACTION && gondolaInfo && gondolaInfo.gateways.map(gateway =>
                <ScaleGatewayDetails key={gateway.scale_gateway_id}
                    gateway={gateway}
                    gondolaId={gondolaId}
                    deploymentId={deploymentId}
                    refetchGondolaInfo={fetchGondolaInfo}
                />)
            }


        </Stack >
    )
}
